<template>
  <div class="clients">
    <div class="clients__title">
      Statistiques avancées
    </div>

    <div class="clients__subtitle">
      Recherche statistiques avancées
    </div>

    <!-- Filter matching old design of StatisticsCustomFilter -->
    <div>
      <div class="custom-filter without-border-bottom">
        <div class="custom-filter__inputs align-start">
          <!-- Durée -->
          <label class="custom-filter__inputs--label">
            Durée
            <div class="checkboxes-wrap--item">
              <label class="checkboxes__element">
                <input
                  type="checkbox"
                  class="checkboxes__element--input"
                  v-model="filters.durations[12]"
                />
                <span class="checkboxes__element--text">12 Mois</span>
              </label>
            </div>
            <div class="checkboxes-wrap--item">
              <label class="checkboxes__element">
                <input
                  type="checkbox"
                  class="checkboxes__element--input"
                  v-model="filters.durations[24]"
                />
                <span class="checkboxes__element--text">24 Mois</span>
              </label>
            </div>
            <div class="checkboxes-wrap--item">
              <label class="checkboxes__element">
                <input
                  type="checkbox"
                  class="checkboxes__element--input"
                  v-model="filters.durations[36]"
                />
                <span class="checkboxes__element--text">36 Mois</span>
              </label>
            </div>
          </label>

          <!-- Date -->
          <div class="custom-filter__inputs--label">
            Date
            <div class="label currency-datepicker">
              <div class="label__input-wrap">
                <datepicker
                  placeholder="De"
                  format="DD/MM/YYYY"
                  :monday-first="true"
                  :full-month-name="true"
                  wrapper-class="currency-datepicker__wrapper-low-margin mb-3"
                  input-class="currency-datepicker__input"
                  calendar-class="currency-datepicker__element"
                  v-model="filters.start_date"
                  @focusout.native="focusOutStartDate"
                  :highlighted="filters.start_date ? '' : highlightedConfig"
                >
                </datepicker>
                <datepicker
                  placeholder="à"
                  format="DD/MM/YYYY"
                  :monday-first="true"
                  :full-month-name="true"
                  wrapper-class="currency-datepicker__wrapper-low-margin"
                  input-class="currency-datepicker__input"
                  calendar-class="currency-datepicker__element"
                  v-model="filters.end_date"
                  @focusout.native="focusOutEndDate"
                  :highlighted="filters.end_date ? '' : highlightedConfig"
                >
                </datepicker>
              </div>
            </div>
          </div>

          <!-- Plage de dates -->
          <label class="custom-filter__inputs--label">
            Plage de dates
            <div class="checkboxes-wrap--item">
              <label class="checkboxes__element">
                <input
                  type="checkbox"
                  class="checkboxes__element--input"
                  v-model="filters.periods.today"
                  :disabled="!isDatesAreEmpty"
                />
                <span class="checkboxes__element--text">Aujourd’hui</span>
              </label>
            </div>
            <div class="checkboxes-wrap--item">
              <label class="checkboxes__element">
                <input
                  type="checkbox"
                  class="checkboxes__element--input"
                  v-model="filters.periods.yesterday"
                  :disabled="!isDatesAreEmpty"
                />
                <span class="checkboxes__element--text">Hier</span>
              </label>
            </div>
            <div class="checkboxes-wrap--item">
              <label class="checkboxes__element">
                <input
                  type="checkbox"
                  class="checkboxes__element--input"
                  v-model="filters.periods.this_week"
                  :disabled="!isDatesAreEmpty"
                />
                <span class="checkboxes__element--text">Cette semaine</span>
              </label>
            </div>
            <div class="checkboxes-wrap--item">
              <label class="checkboxes__element">
                <input
                  type="checkbox"
                  class="checkboxes__element--input"
                  v-model="filters.periods.last_week"
                  :disabled="!isDatesAreEmpty"
                />
                <span class="checkboxes__element--text">La semaine dernière</span>
              </label>
            </div>
            <div class="checkboxes-wrap--item">
              <label class="checkboxes__element">
                <input
                  type="checkbox"
                  class="checkboxes__element--input"
                  v-model="filters.periods.this_month"
                  :disabled="!isDatesAreEmpty"
                />
                <span class="checkboxes__element--text">Ce mois</span>
              </label>
            </div>
            <div class="checkboxes-wrap--item">
              <label class="checkboxes__element">
                <input
                  type="checkbox"
                  class="checkboxes__element--input"
                  v-model="filters.periods.last_month"
                  :disabled="!isDatesAreEmpty"
                />
                <span class="checkboxes__element--text">Le mois dernier</span>
              </label>
            </div>
            <div class="checkboxes-wrap--item">
              <label class="checkboxes__element">
                <input
                  type="checkbox"
                  class="checkboxes__element--input"
                  v-model="filters.periods.this_year"
                  :disabled="!isDatesAreEmpty"
                />
                <span class="checkboxes__element--text">Cette année</span>
              </label>
            </div>
            <div class="checkboxes-wrap--item">
              <label class="checkboxes__element">
                <input
                  type="checkbox"
                  class="checkboxes__element--input"
                  v-model="filters.periods.last_year"
                  :disabled="!isDatesAreEmpty"
                />
                <span class="checkboxes__element--text">L’année dernière</span>
              </label>
            </div>
          </label>
        </div>
      </div>

      <div class="custom-filter__inputs align-start with-border-bottom">
        <label class="custom-filter__inputs--label">
          Montant minimum
          <input
            class="custom-filter__inputs--field text-type"
            v-model="filters.min_amount"
            @keyup.enter="getGaranties(1)"
          />
        </label>
        <label class="custom-filter__inputs--label">
          Client / Praticien
          <input
            class="custom-filter__inputs--field text-type"
            v-model="filters.client_name"
            @keyup.enter="getGaranties(1)"
          />
        </label>
        <label class="custom-filter__inputs--label">
          Société
          <input
            class="custom-filter__inputs--field text-type"
            v-model="filters.company"
            @keyup.enter="getGaranties(1)"
          />
        </label>
        <label class="custom-filter__inputs--label">
          N° Série
          <input
            class="custom-filter__inputs--field text-type"
            v-model="filters.serial_number"
            @keyup.enter="getGaranties(1)"
          />
        </label>
      </div>

      <div class="custom-filter__buttons stats" style="align-items: center; display: flex;">
        <div style="flex-basis: 90%;">
          <button class="custom-filter__buttons--button" @click="getGaranties(1)">Rechercher</button>
        </div>
      </div>
    </div>

    <!-- Guarantees table matching AdvanceStats design -->
    <template v-if="isBusy">
      <Preloader />
    </template>
    <template v-else>
      <div class="block__content--table">
        <table>
          <thead>
            <tr>
              <th>Date</th>
              <th>Nom</th>
              <th>Garantie souscrite</th>
              <th>Prime</th>
              <th>Statut</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="garanty in garantiesSouscrites.data" :key="garanty.id">
              <td>{{ parseDate(garanty) }}</td>
              <td>{{ parseFullName(garanty) }}</td>
              <td>{{ parseTypeGaranty(garanty) }}</td>
              <td>{{ parsePrice(garanty) | formatSeparateComma }}</td>
              <td>{{ parseStatusGaranty(garanty) }}</td>
            </tr>
            <tr v-if="!garantiesSouscrites.data || garantiesSouscrites.data.length === 0">
              <td colspan="5" style="text-align: center; padding: 20px;">
                Aucune garantie trouvée
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <pagination
        :data="garantiesSouscrites"
        :limit="5"
        @pagination-change-page="getGaranties"
      ></pagination>
    </template>
  </div>
</template>

<script>
import Preloader from '@/components/Preloader';
import Datepicker from '@/components/DatepickerCustom/src/components/Datepicker';

export default {
  name: 'DentalStats',
  components: { Preloader, Datepicker },
  data() {
    return {
      garantiesSouscrites: {
        data: [],
      },
      filters: {
        start_date: null,
        end_date: null,
        client_name: '',
        company: '',
        serial_number: '',
        min_amount: '',
        durations: {
          12: false,
          24: false,
          36: false,
        },
        periods: {
          today: false,
          yesterday: false,
          this_week: false,
          last_week: false,
          this_month: false,
          last_month: false,
          this_year: false,
          last_year: false,
        },
      },
      highlightedConfig: {
        dates: [new Date()],
      },
      isBusy: true,
    };
  },
  computed: {
    isDatesAreEmpty() {
      return !this.filters.start_date && !this.filters.end_date;
    },
  },
  methods: {
    focusOutStartDate(event) {
      if (event && event.target && event.target.value === '') {
        this.filters.start_date = null;
      }
    },
    focusOutEndDate(event) {
      if (event && event.target && event.target.value === '') {
        this.filters.end_date = null;
      }
    },
    getFilters() {
      const data = {};
      if (this.filters.start_date) {
        data.subscription_date_start = this.moment(this.filters.start_date).format('YYYY-MM-DD');
      }
      if (this.filters.end_date) {
        data.subscription_date_end = this.moment(this.filters.end_date).format('YYYY-MM-DD');
      }
      if (this.filters.client_name) {
        data.client_name = this.filters.client_name;
      }
      if (this.filters.company) {
        data.company = this.filters.company;
      }
      if (this.filters.serial_number) {
        data.serial_number = this.filters.serial_number;
      }
      if (this.filters.min_amount) {
        data.min_amount = this.filters.min_amount;
      }

      const activeDurations = [];
      for (const dur in this.filters.durations) {
        if (this.filters.durations[dur]) {
          activeDurations.push(Number(dur));
        }
      }
      if (activeDurations.length > 0) {
        data.duration = activeDurations;
      }

      if (this.isDatesAreEmpty) {
        const activePeriods = [];
        for (const p in this.filters.periods) {
          if (this.filters.periods[p]) {
            activePeriods.push(p);
          }
        }
        if (activePeriods.length > 0) {
          data.periods = activePeriods;
        }
      }

      return data;
    },
    getGaranties(page = 1) {
      this.isBusy = true;
      const params = {
        page: page,
        ...this.getFilters(),
      };

      this.apiGet('dental/guarantees', params)
        .then((response) => {
          if (response && response.data) {
            this.garantiesSouscrites = response.data;
          }
        })
        .catch((error) => {
          console.error('Error fetching dental guarantees for statistics:', error);
        })
        .finally(() => {
          this.isBusy = false;
        });
    },
    parseDate(garanty) {
      const d = (garanty && (garanty.subscription_date || garanty.created_at)) ? (garanty.subscription_date || garanty.created_at) : null;
      if (d) {
        return this.moment(d).format('DD/MM/YYYY');
      }
      return ' - ';
    },
    parseFullName(garanty) {
      if (garanty && garanty.dental_client) {
        const name = garanty.dental_client.name || '';
        const comp = garanty.dental_client.company || '';
        if (name && comp) {
          return `${name} (${comp})`;
        }
        return name || comp || ' - ';
      }
      return ' - ';
    },
    parseTypeGaranty(garanty) {
      const duration = (garanty && garanty.duration) ? garanty.duration : 12;
      return `Garantie Dentaire ${duration} mois`;
    },
    parsePrice(garanty) {
      const price = (garanty && garanty.price) ? parseFloat(garanty.price) : 0;
      if (garanty && (garanty.status === 'Credited' || garanty.status === 'credited')) {
        return `-${this.roundEURWithoutSymbol(price)} €`;
      }
      return `${this.roundEURWithoutSymbol(price)} €`;
    },
    parseStatusGaranty(garanty) {
      if (garanty && garanty.status) {
        switch (garanty.status) {
          case 'Active':
          case 'active':
            return 'Valide';
          case 'Inactive':
          case 'inactive':
            return 'Annulée';
          case 'Expired':
          case 'expired':
            return 'Echue';
          case 'Credited':
          case 'credited':
            return 'Sans Effet';
          default:
            return garanty.status;
        }
      }
      return 'Valide';
    },
  },
  mounted() {
    this.getGaranties(1);
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Dental/DentalStats.vue